module.exports = __webpack_public_path__ + "static/media/415SunsetAveNW_2018-06-11_64.b97fd87c.jpg";